export default {
  List: "/Tables/AuditLog/List",
  Info: "/Tables/AuditLog/DataEventDetails",
  Export: "/Tables/AuditLog/Export",
};
